import { Link as RouterLink, type LinkProps } from "react-router-dom";

type MarketingLinkProps = Omit<LinkProps, "to"> & {
  href: LinkProps["to"];
};

export function Link({ href, ...props }: MarketingLinkProps) {
  return <RouterLink to={href} {...props} />;
}
